import { applyMiddleware, createStore } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import { FETCHING_PAGEDATA_SUCCESS } from "./pagedata";
import SettingsTransform from "./transforms";
import { composeWithDevTools } from "redux-devtools-extension";
import { createBrowserHistory } from "history";
import createRootReducer from "./reducers";
import { routerMiddleware } from "connected-react-router";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";

export const history = createBrowserHistory();

const persistConfig = {
  key: "root",
  storage,
  transforms: [SettingsTransform],
  whitelist: ["clipboard", "settings"],
};

const persistedReducer = persistReducer(persistConfig, createRootReducer(history));

const actionSanitizer = (action) =>
  action.type === FETCHING_PAGEDATA_SUCCESS && action.data
    ? { ...action, data: "<<LONG_BLOB>>" }
    : action;

const stateSanitizer = (state) =>
  state?.pagedata?.data?.container?.json_dict
    ? {
        ...state,
        pagedata: {
          ...state.pagedata,
          data: {
            ...state.pagedata.data,
            container: { ...state.pagedata.container, json_dict: "<<LONG_BLOB>>" },
          },
        },
      }
    : state;

const composeEnhancers = composeWithDevTools({ actionSanitizer, stateSanitizer });

export default function configureStore(preloadedState) {
  const middlewares = [routerMiddleware(history), thunk];
  const middlewareEnhancer = applyMiddleware(...middlewares);

  const enhancers = [middlewareEnhancer];

  const composedEnhancers = composeEnhancers(...enhancers);

  const store = createStore(persistedReducer, preloadedState, composedEnhancers);
  const persistor = persistStore(store);

  return { persistor, store };
}
